import React, { useState } from "react";
import { api } from "../../utils";
import toast from "react-hot-toast";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import _ from "lodash";

export default function ForgotPassword(props) {
  const [email, setEmail] = useState();
  const [submitted, setSubmitted] = useState(false);

  function forgotPassword() {
    api.post("account/forgotPassword", { username: email }).then((response) => {
      if (response.isAxiosError) {
        const errorMessage = [];
        _.forEach(response.response.data.errors, function (error) {
          errorMessage.push(error);
        });
        console.log(errorMessage);
        toast.error(
          `There was an error processing your request. ${_.toString(
            errorMessage
          )}`
        );
      } else {
        setSubmitted(true);
      }
    });
  }

  return (
    <Container maxWidth="sm">
      <Card>
        <CardHeader
          title={
            <Typography variant="articleTitle">Forgot Password?</Typography>
          }
        />
        {!submitted ? (
          <>
            <CardContent>
              <Stack spacing={3}>
                <Typography variant="articleText">
                  Please enter the email address associated with your account to
                  be sent a reset password link.
                </Typography>
                <Divider />
                <TextField
                  required
                  color="primary"
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  label={
                    <Typography variant="navText">Account Email</Typography>
                  }
                />
                <Button
                  size="small"
                  color="success"
                  variant="contained"
                  onClick={() => forgotPassword()}
                >
                  Get Link
                </Button>
              </Stack>
            </CardContent>
          </>
        ) : (
          <>
            <CardContent>
              <Stack spacing={2}>
                <Typography variant="articleText">
                  If the email you submitted is in our system, you will receive
                  a reset password link sent to the email address in the next
                  few minutes. The link expires after 24 hours.
                </Typography>
                <Divider flexItem />
                <Typography variant="articleText">
                  If you have not recieved an email from our system, please
                  check your SPAM folder before using "Forgot Password" again.
                </Typography>
                <Typography variant="articleText">- OR -</Typography>
                <Typography variant="articleText">
                  Please email info@hooverandstrong.com with the email address
                  associated with your account to reset your password, or call
                  Information toll-free: 1-800-759-9997 or 804-794-3700.
                </Typography>
              </Stack>
            </CardContent>
          </>
        )}
      </Card>
    </Container>
  );
}
